


<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'hco.mergeHCOSearch' | translate}}</span>
  </div>

  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-6">
          <input type="text"
                 name="name"
                 [(ngModel)]="search.searchText"
                 placeholder="{{'app.Search' |translate}}"
                 #name="ngModel"
                 autocomplete="off" (keydown.enter)='searchHcps()'
                 class="form-control" />
        </div>
        <div class="col-sm-3 margin-top-10 cursor-pointer" (click)="openFilterModal()">
          <span class="margin-right-7 filter-span">{{'app.Filter' | translate}}</span>
          <i class="fa fa-filter" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="panel panel-success widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'hco.mergeHCOSearchResult' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-12">
          <p-table #dt [value]="hcps" [responsive]="true" sortMode="multiple" [paginator]="true" [rows]="pageSize" [resizableColumns]="true"
                   [totalRecords]="totalItems" dataKey="id" selectionMode="multiple"
                   [lazy]="true" (onLazyLoad)="pageChanged($event)" [(selection)]="selectedHcpItems">
            <ng-template pTemplate="header">
              <tr>
                <th width="7%">#</th>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" width={{col.width}} style="text-align:center" pResizableColumn>
                  {{col.header}}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>

              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-hcp let-rowIndex="rowIndex">
              <tr *ngIf="hcps.length>0 && displayMode==2" [pSelectableRow]="hcp" [pSelectableRowIndex]="rowIndex">
               
                <td>Select</td>
                <td>{{ hcp.id }}</td>
                <td>{{ hcp.fullName }}</td>
                <td>{{ hcp.specialityName }}</td>

              </tr>
              <tr *ngIf="hcp.length==0 && displayMode==2">
                <td colspan="5">{{'app.NoDataFound' | translate}}</td>
              </tr>
              <tr *ngIf="displayMode==1">
                <td colspan="5">
                  <div class="row col-sm-12 padding-sm-hr">
                    <div class="container text-center">
                      <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="displayMode==3">
                <td colspan="5">
                  <div class="alert alert-danger alert-dark">
                    <button type="button" class="close" data-dismiss="alert">×</button>
                    {{'app.ServerError' |translate}}.
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
          <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;
          <button class="btn  btn-save" type="submit" (click)="merge()">{{'Merge ('+ selectedHcpItems.length +')' | translate}}</button>
        </div>
      </div>
    </div>
    <div class="col-sm-12 text-center">
      {{ (currentPage - 1) * pageSize + 1 }} - {{ totalItems >= (currentPage * pageSize)? (currentPage * pageSize) : totalItems}} of {{ totalItems }}
    </div>
  </div>
</div>

<div class="modal fade" bsModal #filterModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="filter-title">{{'app.Filter' | translate}}</h1>
      </div>
      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">
        <div class="row">
          <div class="col-sm-12">
            <label class="control-label">{{'app.name' | translate}} </label>
            <input type="text"
                   name="name"
                   [(ngModel)]="search.searchText"
                   placeholder="{{'app.name' |translate}}"
                   #name="ngModel"
                   autocomplete="off"
                   class="form-control" />
          </div>
        </div>
        
        <div class="row">
          <div class="col-sm-12">
            <label class="control-label">{{'pageHeader.Specialities' | translate}} </label>
            <span class="ui-fluid">
              <p-dropdown [options]="specialitys"
                          placeholder="{{'pageHeader.Speciality' | translate}}"
                          emptyFilterMessage="No results found"
                          showClear="true"
                          styleClass="wid100"
                          name="specialityId"
                          #specialityId="ngModel"
                          [(ngModel)]="search.speciality"
                          [filter]="true" optionLabel="name">
              </p-dropdown>
            </span>
          </div>
        </div>

        <div class="panel-footer margin-left-20 margin-top-20">
          <button type="button" (click)="hideFilterModal()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
          <button type="button" class="btn btn-save" (click)="searchFilterModal()">{{'app.Search' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- merge confirmation: the merge is destructive, and the user picks whose rep links stay -->
<div class="modal fade" bsModal #confirmMergeModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog">
    <div class="panel padding-2">
      <h1 class="filter-title">Merge {{selectedHcpItems.length}} HCP(s) into HCP #{{hcpId}}?</h1>
      <div class="panel-body padding-sm-hr">
        <p>The selected HCP(s) will be hidden, and their links, visits and other records will move to HCP #{{hcpId}}.
          A wrong merge can be undone later from "Merged HCPs".</p>
        <ul>
          <li *ngFor="let item of selectedHcpItems">#{{item.id}} {{item.fullName}}</li>
        </ul>
        <p><b>When both have a rep link in the same business unit:</b></p>
        <div class="radio"><label><input type="radio" name="keepRepLinks" [value]="true" [(ngModel)]="keepSurvivingRepLinks" />
          Keep HCP #{{hcpId}}'s own rep link (end the merged HCP's link)</label></div>
        <div class="radio"><label><input type="radio" name="keepRepLinks" [value]="false" [(ngModel)]="keepSurvivingRepLinks" />
          Keep the merged HCP's rep link (end HCP #{{hcpId}}'s own link)</label></div>
      </div>
      <div class="panel-footer margin-left-20 margin-top-20">
        <button type="button" class="btn btn-cancel" (click)="confirmMergeModal.hide()" [disabled]="merging">{{'app.cancel' | translate}}</button>
        <button type="button" class="btn btn-save" (click)="confirmMerge()" [disabled]="merging">{{merging ? 'Merging...' : 'Merge'}}</button>
      </div>
    </div>
  </div>
</div>
